import * as React from 'react';
import { connect } from 'react-redux';

import { actions as ConnectionActions, state as ConnectionState } from '../redux/modules/connection';

const mapDispatchToProps = {
    ...ConnectionActions
};

const mapStateToProps = (state:any) => ({
   connection: state.connection
});

interface IInternalprops {
    connection:ConnectionState;
}

type Props = IInternalprops;


class ApiProvider extends React.Component<Props> {
    public render() {
        return (<div className="App">{ this.props.children }</div>);
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(ApiProvider);



// WEBPACK FOOTER //
// ./src/components/ApiProvider.tsx